function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z",
  fill: "#039BE8"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.75 11.25h1.5v1.5h-1.5v-1.5zm4.5 0h1.5v1.5h-1.5v-1.5zm4.5 0h1.5v1.5h-1.5v-1.5zm-9 3.375h1.5v1.5h-1.5v-1.5zm4.5 0h1.5v1.5h-1.5v-1.5zm4.5 0h1.5v1.5h-1.5v-1.5zM6.75 18h1.5v1.5h-1.5V18zm4.5 0h1.5v1.5h-1.5V18zm4.5 0h1.5v1.5h-1.5V18z",
  fill: "#039BE8"
});

var SvgLineSchedule = function SvgLineSchedule(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z' fill='%23039BE8'/%3E %3Cpath d='M6.75 11.25h1.5v1.5h-1.5v-1.5zM11.25 11.25h1.5v1.5h-1.5v-1.5zM15.75 11.25h1.5v1.5h-1.5v-1.5zM6.75 14.625h1.5v1.5h-1.5v-1.5zM11.25 14.625h1.5v1.5h-1.5v-1.5zM15.75 14.625h1.5v1.5h-1.5v-1.5zM6.75 18h1.5v1.5h-1.5V18zM11.25 18h1.5v1.5h-1.5V18zM15.75 18h1.5v1.5h-1.5V18z' fill='%23039BE8'/%3E %3C/svg%3E";
export { SvgLineSchedule as ReactComponent };